/**
 * BNEF-specific event taxonomy.
 */

export enum TrackingAction {
    Complete = 'complete',
    Click = 'click',
    Close = 'close',
    Copy = 'copy',
    FollowLink = 'followLink',
    Filter = 'filter',
    Open = 'open',
    Search = 'search',
    Skip = 'skip',
    Submit = 'submit',
    SaveItem = 'saveItem',
    UnsaveItem = 'unsaveItem',
    GenerateLink = 'generateLink',
    Download = 'download',
    ChangeTab = 'changeTab',
    Register = 'register',
    Unregister = 'unregister',
    Scroll = 'scroll',
    Translate = 'translate',
    Subscribe = 'subscribe',
    Unsubscribe = 'unsubscribe',
    Play = 'play',
    Switch = 'switch',
}

export enum TrackingCategory {
    AiSummary = 'aiSummary',
    Assets = 'assets',
    HydrogenAssets = 'hydrogenAssets',
    AssetFinancing = 'assetFinancing',
    Author = 'author',
    BatteryPlants = 'batteryPlants',
    BloombergContent = 'bloombergContent',
    BloombergVideo = 'bloombergVideo',
    PolyvVideo = 'polyvVideo',
    BnefContent = 'bnefContent',
    Chart = 'chart',
    ClothesLine = 'clothesLine',
    Event = 'event',
    ESTProjects = 'ESTProjects',
    General = 'general',
    GlobalSearch = 'globalSearch',
    Organizations = 'organizations',
    Recommendations = 'recommendations',
    Popular = 'popular',
    Series = 'series',
    Flagships = 'flagships',
    Discover = 'discoverArea',
    SearchSection = 'searchSection',
    QuickSearch = 'quickSearch',
    Navigation = 'navigation',
    Share = 'share',
    Print = 'print',
    Policies = 'policies',
    SaveButton = 'saveButton',
    Attachment = 'attachment',
    Email = 'email',
    Tableau = 'tableau',
    ExternalContent = 'externalContent',
    ContactForm = 'contactForm',
    RelatedContent = 'relatedContent',
    HelpResource = 'helpResource',
    WindTurbines = 'windTurbines',
    Countries = 'countries',
    Sector = 'sector',
    PowerPurchaseAgreements = 'powerPurchaseAgreements',
    DataAndTools = 'dataAndTools',
    Data = 'data',
    SolarManufacturing = 'solarManufacturing',
    Tour = 'tour',
    Hierarchy = 'hierarchy',
}

export enum TrackedProductTypes {
    Asset = 'assets',
    BatteryPlant = 'batteryPlant',
    HydrogenAsset = 'hydrogenAssets',
    SolarManufacturingAsset = 'solarManufacturingAsset',
    Flagship = 'flagship',
    Insight = 'insight',
    News = 'news',
    Theme = 'theme',
    CountryProfile = 'countryProfile',
    Short = 'short',
    AnalystReaction = 'analystReaction',
    Video = 'video',
    InteractiveDataset = 'interactiveDataset',
    Series = 'series',
    Sector = 'sector',
    Organization = 'organization',
    Policy = 'policy',
    PublicWebinar = 'publicwebinar',
    Webinar = 'webinar',
    PowerPurchaseAgreements = 'power-purchase-agreements',
}

export enum SiteSearchCategory {
    Research = 'research',
    Data = 'data',
    News = 'news',
    Events = 'events',
    Charts = 'charts',
}
